import { Trip } from '../../lib/types/models/trip/trip'
import { TripInput } from '../../lib/types/models/trip/trip-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTrip(data: UpdateInput<TripInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.trips.update.url, { id }))
    .patch<Trip, Partial<TripInput>>(rest)
}
